// 방문객 키 — 로그인하지 않은 방문자도 같은 브라우저에서 대화를 이어 갈 수 있게 localStorage 에 둔다.
// 로그아웃하면 바꿔서(rotate) 다음 사람이 앞 사람의 대화를 보지 못하게 한다.
const KEY = 'qw_chat_vid';
const PATTERN = /^[A-Za-z0-9_-]{12,64}$/;

let memoryKey = '';

function makeKey() {
  const bytes = new Uint8Array(18);
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  const b64 = window.btoa(String.fromCharCode.apply(null, bytes));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function read() {
  try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
}
function write(key) {
  try { localStorage.setItem(KEY, key); } catch (e) { /* 사생활 모드 등 — 메모리 키로 */ }
}

export function getVisitorKey() {
  const stored = read();
  if (PATTERN.test(stored)) return stored;
  if (!memoryKey) memoryKey = makeKey();
  write(memoryKey);
  return memoryKey;
}

export function rotateVisitorKey() {
  memoryKey = makeKey();
  write(memoryKey);
  return memoryKey;
}
